import { createReducer, on, ActionReducerMap } from '@ngrx/store';
import * as OrgActions from './org.actions';
import { OrgTypes } from '@mode/shared/contract-common';

export const orgFeatureKey = 'org';

export interface State {
  isCurrentLoading: boolean;
  isCurrentComplete: boolean;
  current: Readonly<OrgTypes.Organization> | undefined;
  currentError: Error | null;

  isReportLoading: boolean;
  isReportComplete: boolean;
  report: Readonly<OrgTypes.Organization> | undefined;
  reportError: Error | null;
}

export const initialState: State = {
  isCurrentLoading: false,
  isCurrentComplete: false,
  current: undefined,
  currentError: null,

  isReportComplete: false,
  isReportLoading: false,
  report: undefined,
  reportError: null,
};

export const isCurrentLoadingReducer = createReducer(
  initialState.isCurrentLoading,
  on(OrgActions.loadCurrentOrg, (state) => true),
  on(OrgActions.loadCurrentOrgSuccess, (state) => false),
  on(OrgActions.loadCurrentOrgFailure, (state) => false)
);

export const isCurrentCompleteReducer = createReducer(
  initialState.isCurrentComplete,
  on(OrgActions.loadCurrentOrg, (state) => false),
  on(OrgActions.loadCurrentOrgSuccess, (state) => true),
  on(OrgActions.loadCurrentOrgFailure, (state) => true)
);

export const currentReducer = createReducer(
  initialState.current,
  on(OrgActions.loadCurrentOrg, (state) => state),
  on(OrgActions.loadCurrentOrgSuccess, (state, action) => action.org),
  on(OrgActions.loadCurrentOrgFailure, (state, action) => undefined)
);

export const currentErrorReducer = createReducer(
  initialState.currentError,
  on(OrgActions.loadCurrentOrg, (state) => null),
  on(OrgActions.loadCurrentOrgFailure, (state, action) => action.error)
);

export const isReportLoadingReducer = createReducer(
  initialState.isReportLoading,
  on(OrgActions.loadReportOwner, (state) => true),
  on(OrgActions.loadReportOwnerSuccess, (state) => false),
  on(OrgActions.loadReportOwnerFailure, (state) => false)
);

export const isReportCompleteReducer = createReducer(
  initialState.isReportComplete,
  on(OrgActions.loadReportOwner, (state) => false),
  on(OrgActions.loadReportOwnerSuccess, (state) => true),
  on(OrgActions.loadReportOwnerFailure, (state) => true)
);

export const reportReducer = createReducer(
  initialState.report,
  on(OrgActions.loadReportOwner, (state) => state),
  on(OrgActions.loadReportOwnerSuccess, (state, action) => action.org),
  on(OrgActions.loadReportOwnerFailure, (state, action) => undefined)
);

export const reportErrorReducer = createReducer(
  initialState.reportError,
  on(OrgActions.loadReportOwner, (state) => null),
  on(OrgActions.loadReportOwnerFailure, (state, action) => action.error)
);

export const reducer: ActionReducerMap<State> = {
  current: currentReducer,
  currentError: currentErrorReducer,
  isCurrentComplete: isCurrentCompleteReducer,
  isCurrentLoading: isCurrentLoadingReducer,
  report: reportReducer,
  reportError: reportErrorReducer,
  isReportComplete: isReportCompleteReducer,
  isReportLoading: isReportLoadingReducer,
};
